import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { c as classNames } from '../../shared/bind-56cf2a3b.js';
import { jsx } from 'react/jsx-runtime';
import Item from './Item/Item.js';

var styles = {
  "list": "web_ui__List__list",
  "no-trailing-divider": "web_ui__List__no-trailing-divider",
  "tight": "web_ui__List__tight",
  "narrow": "web_ui__List__narrow",
  "default": "web_ui__List__default",
  "wide": "web_ui__List__wide",
  "inline": "web_ui__List__inline"
};

var Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Tight"] = "tight";
  Size["Narrow"] = "narrow";
  Size["Wide"] = "wide";
  return Size;
}(Size || {});
var cssClasses = classNames.bind(styles);
var List = function List(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Default : _ref$size,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    noTrailingDivider = _ref.noTrailingDivider,
    children = _ref.children,
    testId = _ref.testId;
  var listClass = cssClasses(styles.list, _defineProperty({}, styles['no-trailing-divider'], noTrailingDivider));
  return /*#__PURE__*/jsx("ul", {
    className: cssClasses(listClass, size, {
      inline: inline
    }),
    "data-testid": testId,
    children: children
  });
};
List.Item = Item;
List.Size = Size;

export { List as default };
//# sourceMappingURL=List.js.map
